import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import * as d3 from 'd3';
import styled from 'styled-components';
import { TokenData } from 'views/V3Info/types';
import Percent from 'views/V3Info/components/Percent';
import { Flex, Text, useMatchBreakpoints } from '@pancakeswap/uikit';
import { useCurrency } from 'hooks/Tokens';
import { NextRouter, useRouter } from 'next/router';
import { CurrencyLogo } from './Logo';

const StyledCircle = styled.div<{bearish?: boolean}>`
    border: 1px solid white;
    position: absolute;
    border-radius: 100%;
    display: flex;
    // gap: 5%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: translate(-50%, -50%);
    border: 1px solid ${({bearish}) => bearish ? '#E33B32' : '#2EBF43'};
    box-shadow: 0px -26px 36px 0px ${({bearish}) => bearish ? '#E33B324A' : '#2EBF4366'} inset;
    cursor: pointer;
`

const navigateTokenDetail = (router: NextRouter, address: string) => {
    router.push(`/token/${address}`)
}

const Bubble = ({ tokenData }) => {
    const router = useRouter()
    const currency = useCurrency(tokenData.address)
    
    return <StyledCircle onClick={() => {navigateTokenDetail(router, tokenData.address)}} className="circle" bearish={tokenData.priceChange < 0}> {/* size={tokenData.radius * 2} style={{ top: `${tokenData.y}px`, left: `${tokenData.x}px` }}> */}
        <svg viewBox="0 0 100 15" preserveAspectRatio="xMinYMid">
            <text x="50" y="10" fontSize="10" fill={tokenData.priceChange < 0 ? "#E33B32" : "#2EBF43"} textAnchor="middle">
                {tokenData.priceChange < 0 ? '↓' : '↑'}
                {Math.abs(tokenData.priceChange).toFixed(2)}
            </text>
        </svg>
        <CurrencyLogo currency={currency} size='40%' />
        {/* <Text fontSize='100%'>{tokenData.symbol}</Text> */}
        <svg viewBox="0 0 100 30" preserveAspectRatio="xMinYMid">
            <text x="50" y="22" fontSize="15" fill="white" textAnchor="middle">{currency?.symbol ?? tokenData.symbol}</text>
        </svg>
    </StyledCircle>
}

const BubbleChart = ({ tokens }: { tokens: any[] }) => {
    const divRef = useRef(null)
    const { isMobile } = useMatchBreakpoints()

    useEffect(() => {
        const width = divRef.current.clientWidth;
        const height = 500;

        const padding = isMobile ? 2 : 10
        const min = Math.min(...tokens.map(d => Math.abs(d.priceChange)))
        const max = Math.max(...tokens.map(d => Math.abs(d.priceChange)))
        const radiusScale = d3.scaleSqrt().domain([min, max]).range(isMobile ? [30, 60] : [60, 120]);
        // const div = createRoot(divRef.current);

        const nodes = tokens.map((d) => ({
            ...d,
            radius: radiusScale(Math.abs(d.priceChange))
        }))
        // @ts-ignore
        d3.forceSimulation(nodes)
            .force('center', d3.forceCenter(width / 2, height / 2))
            .force('x', d3.forceX().strength(0.1))
            .force('y', d3.forceY().strength(0.1 * width / height))
            // @ts-ignore
            .force('collision', d3.forceCollide().radius(d => d.radius + padding))
            .on('end', adjustHeight)
            .on('tick', () => {
                ticked()
                // if (simulation.alpha() < 0.1) {
                //     // nodes.forEach(d => {
                //     //     d.x += (Math.random() - 0.5) * 5;
                //     //     d.y += (Math.random() - 0.5) * 5;
                //     // });
                //     simulation.alpha(0.8).restart();
                // }
            });

        const container = d3.select(divRef.current)

        const circles = container.selectAll('div.circle')
            .data(nodes)
            .style('width', d => `${d.radius * 2}px`)
            .style('height', d => `${d.radius * 2}px`)

        function ticked() {
            // @ts-ignore
            const minX = d3.min(nodes, d => d.x - d.radius - padding);
            // @ts-ignore
            const minY = d3.min(nodes, d => d.y - d.radius - padding);
            // @ts-ignore
            const maxX = d3.max(nodes, d => d.x + d.radius + padding);
            // @ts-ignore
            const maxY = d3.max(nodes, d => d.y + d.radius + padding);
            
            circles
                // @ts-ignore
                .style('left', d => `${d.x - minX + (width/2 - (maxX - minX)/2)}px`)
                // @ts-ignore
                .style('top', d => `${d.y - minY}px`)

            const newHeight = maxY - minY + padding * 2;
            container.style('height', `${newHeight + padding * 2}px`)
        }

        function adjustHeight() {
            
        }
    }, [tokens, divRef, isMobile, divRef.current?.clientWidth]);

    return <>
        <div ref={divRef} style={{ width: '100%', position: 'relative', overflowX: 'auto' }}>
        {
            tokens.map(token => 
                <Bubble key={token.address} tokenData={token} />
            )
        }
        </div>
    </>
};

export default BubbleChart;
